// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityRequestSearchRequest {
    static getAttributeTypeMap() {
        return MedicalEligibilityRequestSearchRequest.attributeTypeMap;
    }
}
MedicalEligibilityRequestSearchRequest.discriminator = undefined;
MedicalEligibilityRequestSearchRequest.additionalProperties = false;
MedicalEligibilityRequestSearchRequest.attributeTypeMap = [
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "mock",
        "baseName": "mock",
        "type": "boolean"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityRequestSearchRequest.js.map